import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SliderModule } from '../slider/slider.module';
import { PdfBookViewerComponent } from './pdf-book-viewer.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        SliderModule,
    ],
    exports: [PdfBookViewerComponent],
    declarations: [PdfBookViewerComponent],
})
export class PdfBookViewerModule { }
